import { Link } from 'gatsby';
import styled from '../theme/styled-components';
import { LightIcon } from './Icon';

export const Header = styled.div`
  background: ${props => props.theme.colors.typography.dark.base};
  position: sticky;
  top: 0;
  z-index: 200;
`;

interface ISubHeader {
  open?: boolean;
}
export const SubHeader = styled.div<ISubHeader>`
  background-color: ${props => props.theme.colors.typography.dark.base};
  color: ${props => props.theme.colors.typography.light.base};
  position: sticky;
  z-index: 200;

  // Calc subheader position
  top: calc(
    ${props => props.theme.typography.brandTagline.lineHeight} +
      (${props => props.theme.spacings.tiny} * 2)
  );

  ${media => media.theme.media.lessThan('downMedium')`
    display: ${props => (!(props as any).open ? 'none' : undefined)};
  `}

  ${media => media.theme.media.greaterThan('medium')`
    background-color: ${props => props.theme.colors.typography.light.base};
    color: ${props => props.theme.colors.typography.dark.base};
    border-bottom: 1px solid ${props => props.theme.colors.border.dark.base};
  `}
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SubHeaderWrapper = styled(HeaderWrapper)`
  ${media => media.theme.media.lessThan('downMedium')`
    padding-bottom: ${props => props.theme.spacings.base};
  `}
`;

export const HeaderTitle = styled.h1`
  display: flex;
  align-self: stretch;
  align-items: center;
  color: ${props => props.theme.colors.typography.light.base};
  font-size: ${props => props.theme.typography.title.fontSize};
  font-weight: ${props => props.theme.typography.brandTagline.fontWeight};
  font-family: ${props => props.theme.typography.brandTagline.fontFamily};
  text-transform: uppercase;
  margin-bottom: 0;
  padding-top: ${props => props.theme.spacings.tiny};
  padding-bottom: ${props => props.theme.spacings.tiny};
  transition: background-color 0.2s ease;
  &:hover {
    background-color: ${props => props.theme.colors.primary.base};
  }
`;

export const HeaderLink = styled(Link)`
  color: ${props => props.theme.colors.typography.light.base};

  &:hover,
  &:focus {
    color: ${props => props.theme.colors.typography.light.hover};
    text-decoration: none;
  }
`;

export const HeaderMenuIcon = styled(LightIcon)`
  :hover {
    cursor: pointer;
  }
  ${media => media.theme.media.greaterThan('medium')`
    display: none;
  `}
`;

export const HeaderMenu = styled.ul`
  display: flex;
  list-style: none;
  margin-left: 0;
  margin-bottom: 0;
  padding-left: 0;
  width: 100%;

  ${media => media.theme.media.lessThan('downMedium')`
    display: block;
  `}
`;

export const HeaderMenuItem = styled.li`
  font-weight: ${props => props.theme.typography.brandTitle.fontWeight};
  position: relative;
`;

export const TranslateList = styled.div`
  display: flex;
`;

interface IHeaderSubMenu {
  openService?: boolean;
}

export const HeaderSubMenu = styled.ul<IHeaderSubMenu>`
  list-style: circle;

  padding-left: ${props => props.theme.spacings.medium};
  display: ${props => (!(props as any).openService ? 'none' : undefined)};

  ${media => media.theme.media.greaterThan('medium')`
      padding-left: 0;
      list-style: none;
      left: 50%;
      transform: translateX(-50%);
      position: absolute;
      background: #fff;
      border: 1px solid ${props => props.theme.colors.border.dark.base};
      width: 15rem;

      :after, :before {
        bottom: 100%;
        left: 50%;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
      }

      :before {
        border-color: rgba(236, 236, 236, 0);
        border-bottom-color: ${props => props.theme.colors.border.dark.base};

        border-width: 7px;
        margin-left: -7px;
      }

      :after {
        border-color: rgba(255, 255, 255, 0);
        border-bottom-color: #fff;
        border-width: 6px;
        margin-left: -6px;
      }
  `}
`;

export const HeaderSubMenuItem = styled.li`
  :hover {
    cursor: pointer;
  }
`;
